// Thin client for the DAMS Rent a Car backend.
// Single source of truth for inventory, auth, bookings, payments.
// docs / OpenAPI: https://rental-routes.emergent.host/openapi.json
import axios from "axios";

export const DAMS_API_BASE = "https://rental-routes.emergent.host";
const TOKEN_KEY = "auth_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const dams = axios.create({
  baseURL: DAMS_API_BASE,
});

dams.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

dams.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
    }
    return Promise.reject(err);
  }
);

// ---------- AUTH ----------
export const auth = {
  register: ({ email, password, name, phone, adult_confirmed }) =>
    dams
      .post("/api/auth/register", {
        email,
        password,
        name,
        phone,
        terms_accepted: true,
        adult_confirmed: adult_confirmed === true,
      })
      .then((r) => r.data),
  login: ({ email, password }) =>
    dams.post("/api/auth/login", { email, password }).then((r) => r.data),
  me: () => dams.get("/api/auth/me").then((r) => r.data),
  logout: () => dams.post("/api/auth/logout").then((r) => r.data).catch(() => null),
  forgot: (email) =>
    dams.post("/api/auth/forgot-password", { email }).then((r) => r.data),
  reset: ({ email, code, new_password }) =>
    dams
      .post("/api/auth/reset-password", { email, code, new_password })
      .then((r) => r.data),
};

// ---------- BOOKINGS ----------
export const bookings = {
  create: (payload) => dams.post("/api/bookings", payload).then((r) => r.data),
  list: () => dams.get("/api/bookings").then((r) => r.data),
  get: (id) => dams.get(`/api/bookings/${id}`).then((r) => r.data),
  receiptPdfUrl: (id) =>
    `${DAMS_API_BASE}/api/bookings/${id}/receipt.pdf?token=${encodeURIComponent(
      getToken() || ""
    )}`,
};

// ---------- PAYMENTS ----------
export const payments = {
  checkout: ({ booking_id, origin_url }) =>
    dams
      .post("/api/payments/checkout", { booking_id, origin_url })
      .then((r) => r.data),
  status: (session_id) =>
    dams.get(`/api/payments/status/${session_id}`).then((r) => r.data),
};

// ---------- PROMO ----------
export const promo = {
  validate: ({ code, subtotal }) =>
    dams.post("/api/promo-codes/validate", { code, subtotal }).then((r) => r.data),
};

// ---------- LOCATIONS ----------
export const locations = {
  // Returns tax/refuel/mileage policy for a named location
  taxByName: (name) =>
    dams
      .get("/api/locations/tax-by-name", { params: { name } })
      .then((r) => r.data),
};
